import { FunctionComponent } from 'react';
import { DialogModal } from '../../../app-kit/components/DialogModal/DialogModal';
import { StatePageVGDisclaimerModalContentWithData } from './StatePageVGDisclaimerModalContent/StatePageVGDisclaimerModalContentWithData';

interface VGDisclaimerModal {
  opened: boolean;
  onClose: () => void;
}

export const StatePageVGDisclaimerModal: FunctionComponent<VGDisclaimerModal> = ({
  opened,
  onClose,
}) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
      title="Disclaimer"
    >
      <StatePageVGDisclaimerModalContentWithData />
    </DialogModal>
  );
};
